export enum PageType {
  Search = 'search',
  Category = 'category',
  Partner = 'partner',
  AllProducts = 'allProducts',
}

export type FilterNavType = 'sticky filter' | 'collapsed sidebar' | 'fixed sidebar';
